import axios from 'axios'
import { i18n } from '../../../plugins/i18n'

export const companiesLocationStore = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
  },
  getters: {
    store: (state) => state.data
  },
  mutations: {
    initNewStore(state) {
      state.data = {
        name: null,
        location: null,
        brand_id: null
      }
      state.loading = false
      state.loadError = false
    },
    readStore(state) {
      state.data = null
      state.loading = true
      state.loadError = false
    },
    readStoreSuccess(state, payload) {
      state.data = payload.data
      if (state.data.attributes.address_lines.length === 0) state.data.attributes.address_lines.push('')
      state.loading = false
      state.loadError = false
    },
    readStoreFailure(state) {
      state.loading = false
      state.loadError = true
    },
    createStore(state) {
      state.loading = true
    },
    createStoreSuccess(state) {
      state.loading = false
    },
    createStoreFailure(state) {
      state.loading = false
    },
    updateStore(state) {
      state.loading = true
    },
    updateStoreSuccess(state) {
      state.loading = false
    },
    updateStoreFailure(state) {
      state.loading = false
    }
  },
  actions: {
    initNewStore({ commit }) {
      commit('initNewStore')
    },
    readStore({ commit }, { company_uuid, store_uuid }) {
      commit('readStore')
      return axios
        .get('/api/companies/' + company_uuid + '/location/stores/' + store_uuid + '.json')
        .then(res => {
          commit('readStoreSuccess', res.data)
        })
        .catch(err => {
          commit('readStoreFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
    async createStore({ commit, state }, {company_uuid, payload}) {
      if (state.loading) return

      commit('flash/clearFlash', null, { root: true })
      commit('createStore')
      return axios
        .post('/api/companies/' + company_uuid + '/location/stores.json', payload)
        .then((res) => {
          commit('createStoreSuccess')
          return res.data
        })
        .catch(err => {
          console.error(err)
          commit('createStoreFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    async updateStore({ commit, state }, {company_uuid, store_uuid, store, synced, enableMultiLang}) {
      if (state.loading) return

      const attributes = store.attributes
      const store_params = {
        brand_id: attributes.brand_id,
        name: attributes.name,
        description: attributes.description,
      }
      const store_address_params = {
        postal_code: attributes.postal_code,
        prefecture: attributes.prefecture,
        lines: attributes.address_lines,
      }
      const store_phones_params = [attributes.primary_phone, ...attributes.additional_phones].filter(phone => phone.number)
      const synced_params = synced ? {
        name_synced: synced.name_synced,
        description_synced: synced.description_synced,
        address_synced: synced.address_synced,
        phone_synced: synced.phone_synced,
        website_url_synced: synced.website_url_synced
      } : null
      const storeMultiLanguage = enableMultiLang && attributes.store_multi_language && (attributes.store_multi_language.en_name || attributes.store_multi_language.zh_tw_name || attributes.store_multi_language.ko_name) ? {
        id: attributes.store_multi_language.id,
        en_name: attributes.store_multi_language.en_name,
        zh_tw_name: attributes.store_multi_language.zh_tw_name,
        ko_name: attributes.store_multi_language.ko_name,
      } : null

      const payload = {
        store: store_params,
        store_phones: store_phones_params,
        store_address: store_address_params,
        store_gmb_location: synced_params,
        store_fax_phone: { number: attributes.fax_phone_number },
        store_multi_language: storeMultiLanguage,
        store_web_site_url: attributes.web_site_url,
        store_site_types: attributes.site_types
      }

      commit('flash/clearFlash', null, { root: true })
      commit('updateStore')
      return axios
        .put('/api/companies/' + company_uuid + '/location/stores/' + store_uuid + '.json', payload)
        .then(() => {
          commit('updateStoreSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updatedInfo', { value: i18n.t('models.store.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('updateStoreFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
  }
}
